import { template } from "../../internal/skins/minimal-video/template.js";
import { SkinElement } from "../skin.js";
import minimal_skin_default from "../../define/video/minimal-skin2.js";
import { createShadowStyle } from "@videojs/utils/dom";
//#region src/presets/video/minimal-skin.ts
/** Packaged Minimal video UI registered as `<video-minimal-skin>`. */
var MinimalVideoSkinElement = class extends SkinElement {
	static {
		this.tagName = "video-minimal-skin";
	}
	static {
		this.styles = createShadowStyle(minimal_skin_default);
	}
	static {
		this.template = template;
	}
};
//#endregion
export { MinimalVideoSkinElement };
